"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsPopover = void 0;
const react_1 = __importDefault(require("react"));
const className_1 = require("../../utils/className");
exports.SmlsPopover = ({ id, content = 'Mensagem de 1 linha', isVisible = true, position, dark = false, }) => {
    return (react_1.default.createElement("div", { id: id, className: className_1.mapToCssModules([
            'popover',
            position,
            dark ? 'dark' : '',
            isVisible ? 'show' : '',
        ]) }, typeof content === 'string' ? react_1.default.createElement("span", null, content) : content));
};
//# sourceMappingURL=index.js.map